const toggleNavBtn = document.querySelector('.navbar__toggle');

toggleNavBtn.addEventListener('click', () => {
  const navBtnContainer = document.querySelector('.navbar__links-container');
  if (navBtnContainer.classList.contains('show-links')) {
    navBtnContainer.classList.remove('show-links');
  } else {
    navBtnContainer.classList.add('show-links');
  }
})